import { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";
import { activeConnectionsFilter } from "./Connections/MyConnections";

export const useConnectionsCount = () => {
  const { totalQueryAudience: connectionsCount } = useAudienceInfiniteQuery({
    filters: [activeConnectionsFilter],
    perPage: 1,
  });

  return { connectionsCount };
};
